<template>
    <TheHeader />
    <main class="content-wrapper" :class="contentWrapperClass">
        <div class="content">
            <router-view />
        </div>
    </main>
    <TheMessage />
</template>

<script>
import TheHeader from '@/components/TheHeader';
import TheMessage from '@/components/TheMessage';
import { mapState, mapMutations } from 'vuex';
import { MESSAGE_TYPE } from '@/constants/message';
import queryString from 'query-string';
import { isMeyaSplit, isMeyaHWMGame } from '@/helpers/meyaHandler';
// import api from '@/api';
import { getUserParams } from '@/helpers/meyaHandler';

export default {
    name: 'App',
    components: {
        TheHeader,
        TheMessage,
    },
    data: () => ({
        intervalOfMeyaSectionCheck: null,
        meyaAnimationDuration: 600,
        orbChat: null,
    }),
    computed: {
        ...mapState({
            locale: state => state.urlParams.lang,
            urlParams: state => state.urlParams,
        }),
        isMeyaPageOpened() {
            return this.$router.currentRoute.value.name === 'MeyaChat'
        },
        contentWrapperClass() {
            if (isMeyaHWMGame() && isMeyaSplit()) {
                return this.isMeyaPageOpened ? 'hwm-background' : 'hwm-background tint'
            } else {
                return this.isMeyaPageOpened ? 'hwm-background' : ''
            }
        },
    },
    watch: {
        orbChat(newValue) {
            if (newValue) {
                if (this.isMeyaPageOpened) {
                    newValue.classList.remove('hidden');
                } else {
                    newValue.classList.add('hidden');
                }
            }
        },
        isMeyaPageOpened(newValue) {
            if (this.orbChat) {
                if (newValue) {
                    this.orbChat.classList.remove('hidden')
                } else {
                    this.orbChat.classList.add('hidden')
                }
            }
        },
    },
    async created() {
        this.showMessage({
            text: this.$t('message.loading'),
            type: MESSAGE_TYPE.WAITING
        });
        if (typeof urlData!=='undefined') {
            // eslint-disable-next-line no-undef
            this.setUrlParams(urlData)
        } else {
            this.setUrlParams(queryString.parse(window.location.search))
        }
        this.setQueryParams(this.urlParams)

        this.$i18n.locale = this.locale

        this.applyTheme(this.urlParams.game, this.urlParams.platform, this.urlParams.theme)

        const isParamsHasFaqPage = 'page' in this.urlParams
        const isParamsHasPreset = 'preset' in this.urlParams
        this.setRedirectToFaqPage(isParamsHasFaqPage && !isParamsHasPreset)

        if (isMeyaHWMGame() && isMeyaSplit()) {
            this.meyaInit()
        }
    },
    methods: {
        ...mapMutations({
            showMessage: 'message/show',
            setUrlParams: 'setUrlParams',
            setQueryParams: 'setQueryParams',
            setRedirectToFaqPage: 'routing/setRedirectToFaqPage',
        }),
        applyTheme(game, platform, theme = 'default') {
            const value = `${game}-${platform}-${theme}`;
            document.documentElement.setAttribute('data-theme', value);
        },
        meyaInit() {
            this.setMeyaOpenObserver()
            this.setMeyaLoadingObserver()

            const { appId, uid, iid, ram, width, height, lang, platform, game } = getUserParams()

            // const requestBody = { platform: 'mb', accountId: uid }
            // api.getMeyaParams(requestBody).then(response => {
            //     const data = response.data.answer
            //     const appVersion = data.appVersion
            //     const vipPoints = data.vipPoints
            //     const ipAddress = data.ipAddress

            const eventStreamCallback = (data) => {
                const event = data.events[0]
                const meyaMessages = {
                    openPage: 'meya.session.event.page.open',
                    openChat: 'meya.session.event.chat.open',
                }
                if (event.type === meyaMessages.openChat) {
                    this.setMeyaBackground()
                }
            }

            const connectionOptions = {
                gridUrl: 'https://grid.meya.ai',
                appId,
                integrationId: 'integration.orb',
                onFirstConnect: (connectData, next) => {
                    window.orb.addListener('eventStream', eventStreamCallback)
                    next()
                },
                connect: false,
                userId: uid,
                threadId: 'main',
                pageContext: {
                    'zd_360015186739': iid,
                    'zd_360015186759': {
                        'userAgent': navigator.userAgent,
                        'socId': uid,
                        'localtime': new Date().toString(),
                        // appVersion,
                        'vendor': 'google',
                        'resolution': {
                            width,
                            height
                        },
                        'RAM': ram,
                        // 'ip': ipAddress,
                    },
                    'zd_360015218700': lang,
                    'zd_21707382': platform,
                    'zd_360015230900': game,
                    // 'zd_360016637259': vipPoints,
                    'zd_360019940140': uid,
                }
            }

            window.orbConfig = {
                connectionOptions,
                theme: { 'brandColor': '#4989ea' },

                windowApi: true,

                launcher: {
                    type: 'message',
                    text: this.$t('meya.bubleText'),
                },
            };
            (function() {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = 'https://cdn.meya.ai/v2/orb-fs.js';
                document.body.appendChild(script);
                var fontStyleSheet = document.createElement('link');
                fontStyleSheet.rel = 'stylesheet';
                fontStyleSheet.href = 'https://cdn.meya.ai/font/inter.css';
                document.body.appendChild(fontStyleSheet);
            })();
            // })
        },
        setMeyaOpenObserver() {
            const html = document.documentElement
            const options = {
                attributes: true
            }

            const callback = (mutationList) => {
                mutationList.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const isMeyaPageOpened = mutation?.target?.classList?.contains('orb-chat-full-screen')
                        if (isMeyaPageOpened) {
                            clearInterval(this.intervalOfMeyaSectionCheck)
                        } else {
                            setTimeout(() => {
                                this.clearMeyaBackground()
                            }, this.meyaAnimationDuration)
                        }
                    }
                })
            }

            const observer = new MutationObserver(callback)
            observer.observe(html, options)
        },
        prepareMeyaBackground() {
            const orb = document.getElementsByClassName('orb-chat-mount')[0]
            const meyaMain = orb.childNodes[0]

            return { meyaMain }
        },
        setMeyaBackground() {
            const { meyaMain } = this.prepareMeyaBackground()

            meyaMain.classList.add('hwm-background', 'tint')

            this.intervalOfMeyaSectionCheck = setInterval(() => {
                const meyaSection = meyaMain.childNodes[0]
                meyaSection.classList.add('transparent-section')
            }, 50)
        },
        clearMeyaBackground() {
            const { meyaMain } = this.prepareMeyaBackground()

            meyaMain.classList.remove('hwm-background', 'tint')

            const meyaSection = meyaMain.childNodes[0]
            meyaSection.classList.add('transparent-section')
        },
        setMeyaLoadingObserver() {
            const html = document.body
            const options = {
                childList: true,
            }

            const callback = (mutationList) => {
                mutationList.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        const element = mutation.addedNodes[0]
                        if (element?.classList?.contains('orb-chat-mount')) {
                            this.orbChat = element
                        }
                    }
                })
            }

            const observer = new MutationObserver(callback)
            observer.observe(html, options)
        },
    },
};
</script>

<style lang="scss">
  @import "@/styles/main";
</style>
